import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { Item, Menu } from 'react-contexify';

import openDomain from '../../utils/openDomain';
import { toggleSingleDomainVisibility } from '../../redux/sonar/sonarReducer';

function SonarTableContextMenu({ id, hideLabel }) {
  const { t } = useTranslation('sonar');
  const dispatch = useDispatch();

  const handleOpenWebsite = ({ props: { domain } }) => {
    openDomain(domain);
  };

  const handleToggleDomainVisibility = ({ props: { domain } }) => {
    dispatch(toggleSingleDomainVisibility(domain));
  };

  return (
    <Menu id={id} animation='scale'>
      <Item onClick={handleToggleDomainVisibility}>{hideLabel}</Item>
      <Item onClick={handleOpenWebsite}>{t('visitWebsite')}</Item>
    </Menu>
  );
}

export default SonarTableContextMenu;
